module.exports = __webpack_public_path__ + "static/media/500011.887d7176.svg";